import ReviewerScreeningVote from '../ReviewerScreeningVote';
import ScreeningOutcome from '../ScreeningOutcome';
import BaseEventPayload from './BaseEventPayload';

export default class ScreeningEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(ScreeningEventPayload, data, parentEventLog);
    this.screeningState = data.screeningState;
    this.screeningVote =
      data.screeningVote &&
      new ReviewerScreeningVote(data.screeningVote);
    this.screeningOutcome =
      data.screeningOutcome &&
      new ScreeningOutcome(data.screeningOutcome);
  }
}
